/* eslint-disable no-nested-ternary */
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
  FaChevronDown, FaChevronUp, FaTimesCircle,
} from 'react-icons/fa';
import { getSocieties } from '../../../../api/queries';
import Table from '../../../../components/table';
import WriterDetails from './WriterDetails';
import WritersForm from './writersForm';
import WriterAmendmentsPill from '../../../../components/writerAmendmentsPill';

// Our table component
function WritersTable({
  data, highlightColour,
}) {
  const { t } = useTranslation('writers');
  const societies = getSocieties();
  const [editModal, setEditModal] = useState(null);

  const columns = React.useMemo(
    () => [
      {
        Header: t('writers:writer-name-col'),
        accessor: 'writername',
        width: '25%',
        id: 'colWriterTableName',
      },
      {
        Header: t('writers:pro-membership-col'),
        accessor: (row) => {
          // eslint-disable-next-line react/destructuring-assignment
          if (!row.societycisaccode) {
            return null;
          }
          if (societies.data) {
            const pro = societies.data.societies.find((s) => s.cisaccode === row.societycisaccode);
            return pro?.name;
          }
          return null;
        },
        width: '25%',
        id: 'colWriterTablePRO',
      },
      {
        Header: 'CAE/IPI#',
        accessor: 'caeipinumber',
        width: '25%',
        id: 'colWriterTableCAE',
      },
      {
        Header: t('writers:writer-amendment-status'),
        accessor: 'verifiedstate',
        width: '20%',
        id: 'colVerifiedState',
        Cell: ({ row }) => (
          <div>
            <WriterAmendmentsPill object={row.original} />
          </div>
        ),
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        width: '5%',

        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span>
            {row.isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        ),
        // We can override the cell renderer with a SubCell to be used with an expanded row
        SubCell: () => null, // No expander on an expanded row
      },

    ],
    [societies.isSuccess],
  );

  const generateWriterName = (person) => {
    let fullName = `${person.firstname} ${person.lastname}`;

    if (person?.middlename) {
      fullName = `${person.firstname} ${person.middlename} ${person.lastname}`;
    }

    return fullName;
  };

  const addedWriterNameField = data.map((person) => ({ ...person, writername: generateWriterName(person) }));

  return (
    <>
      {editModal !== null && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white h-modal relative w-11/12 lg:w-auto">
            <button
              type="button"
              onClick={() => setEditModal(null)}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="overflow-y-scroll h-modal p-4 lg:p-8">
              <WritersForm id={editModal} modal closeModal={() => setEditModal(null)} />
            </div>
          </div>
        </div>
      )}
      <Table
        area="WritersTable"
        data={addedWriterNameField}
        columns={columns}
        highlightColour={highlightColour}
        revealComponent={
          <WriterDetails modal highlightColour={highlightColour} setEditModal={setEditModal} />
        }
        searchSuffix={t('common:writers')}
      />
    </>

  );
}

export default WritersTable;
